import clsx from "clsx";

export type SkeletonLoadingProps = {
  bgClassName?: string;
  rows?: number;
  cols?: number;
  showPadding?: boolean;
  roundedSize?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "full";
  gap?: 2 | 4;
};

export const SkeletonLoading = ({
  rows = 1,
  cols = 1,
  showPadding = true,
  bgClassName,
  roundedSize = "md",
  gap = 2,
}: SkeletonLoadingProps) => {
  return (
    <div
      className={clsx(
        "absolute",
        "z-50",
        "inset-0",
        "flex",
        "flex-col",
        "content-between",
        gap === 2 && "gap-2",
        gap === 4 && "gap-4",
        bgClassName ? bgClassName : "bg-white",
        showPadding && "p-4"
      )}
      data-testid="skeleton-loading"
    >
      {[...Array(rows).keys()].map((row) => (
        <div className="flex h-full gap-2" key={`skeleton-loading-row-${row}`} data-testid="skeleton-loading-row">
          {[...Array(cols).keys()].map((col) => (
            <div
              key={`skeleton-loading-col-${col}`}
              data-testid="skeleton-loading-col"
              className={clsx("bg-background-surface-neutral-subtle", "animate-pulse", "w-full", {
                "rounded-xs": roundedSize === "sm",
                "rounded-md": roundedSize === "md",
                "rounded-lg": roundedSize === "lg",
                "rounded-xl": roundedSize === "xl",
                "rounded-2xl": roundedSize === "2xl",
                "rounded-3xl": roundedSize === "3xl",
                "rounded-full": roundedSize === "full",
              })}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

SkeletonLoading.displayName = "SkeletonLoading";
